module.exports = __webpack_public_path__ + "img/104ne.e9e38da8.svg";